import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { APP_ROUTES } from '../constants/routes.constants';

const requireAuth = (): ReturnType<CanActivateFn> => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([APP_ROUTES.auth.login]);
};

const requireGuest = (): ReturnType<CanActivateFn> => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  const destination = auth.isAdmin() ? APP_ROUTES.admin.dashboard : APP_ROUTES.builder.dashboard;
  return router.createUrlTree([destination]);
};

/** Redirects unauthenticated users to /auth/login */
export const authGuard: CanActivateFn = () => requireAuth();

/** Prevents protected lazy routes from matching for unauthenticated users */
export const authMatchGuard: CanMatchFn = () => requireAuth();

/** Redirects already-authenticated users away from auth pages */
export const guestGuard: CanActivateFn = () => requireGuest();

/** Prevents guest-only lazy routes from matching for authenticated users */
export const guestMatchGuard: CanMatchFn = () => requireGuest();
